import { Component } from '@angular/core';
import { LoaderSpinnerService } from '@carm/_core/interceptors/loader-spinner.service';

@Component({
  selector: 'carm-loader-spinner-no-refresh',
  templateUrl: './loader-spinner-no-refresh.component.html',
  styleUrls: ['./loader-spinner-no-refresh.component.scss']
})
export class LoaderSpinnerNoRefreshComponent  {

  constructor(public loaderSpinnerService: LoaderSpinnerService) { }


}
